import { render } from "./TaskView.vue?vue&type=template&id=f7560dba&scoped=true"
import script from "./TaskView.vue?vue&type=script&lang=ts"
export * from "./TaskView.vue?vue&type=script&lang=ts"

import "./TaskView.vue?vue&type=style&index=0&id=f7560dba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f7560dba"

export default script